import { toast } from 'react-toastify'
// import { dummyProducts } from './dummyData'

const wishlistHelper = {
 addToWishlist: (e, product) => {
 e?.stopPropagation()
 e?.preventDefault()

 if (!product) return;

 let wishlist = JSON.parse(localStorage.getItem('wishlist')) || []
 const exists = wishlist.find(item => item._id === product._id)

 if (exists) {
 wishlist = wishlist.filter(item => item._id !== product._id)
 localStorage.setItem('wishlist', JSON.stringify(wishlist))
 toast.info("Removed from Wishlist")
 return { success: true, action: 'removed' }
 } else {
 wishlist.push(product)
 localStorage.setItem('wishlist', JSON.stringify(wishlist))
 toast.success("Added to Wishlist")
 return { success: true, action: 'added' }
 }
 },

 isInWishlist: (id) => {
 const wishlist = JSON.parse(localStorage.getItem('wishlist')) || []
 return !!wishlist.find(item => item._id === id)
 }
}

export default wishlistHelper
